module.exports = __webpack_public_path__ + "img/elgato.bc30a7ce.svg";